import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import AppShell from "@/components/AppShell";
import Dashboard from "@/pages/Dashboard";
import Orders from "@/pages/Orders";
import Products from "@/pages/Products";
import Services from "@/pages/Services";
import Inventory from "@/pages/Inventory";
import Vendors from "@/pages/Vendors";
import Agencies from "@/pages/Agencies";
import Staff from "@/pages/Staff";
import Payroll from "@/pages/Payroll";
import Expenses from "@/pages/Expenses";
import PurchaseOrders from "@/pages/PurchaseOrders";
import Insights from "@/pages/Insights";
import Settings from "@/pages/Settings";
import { DateRangeProvider } from "@/lib/dateRange";
import { CurrencyProvider } from "@/lib/currency";
import { ChannelProvider } from "@/lib/channel";
import { LanguageProvider } from "@/lib/language";

function App() {
  useEffect(() => {
    document.title = "Luna Accounting Studio — Salon Operations";
  }, []);

  return (
    <div className="App font-body antialiased text-[#1C1C1E]">
      <LanguageProvider>
        <CurrencyProvider>
          {/* BrowserRouter wraps the filter providers so they can use useSearchParams */}
          <BrowserRouter>
            <ChannelProvider>
              <DateRangeProvider>
                <Routes>
                  <Route path="/" element={<AppShell />}>
                    <Route index element={<Navigate to="/dashboard" replace />} />
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="orders" element={<Orders />} />
                    <Route path="services" element={<Services />} />
                    <Route path="products" element={<Products />} />
                    <Route path="inventory" element={<Inventory />} />
                    <Route path="vendors" element={<Vendors />} />
                    <Route path="agencies" element={<Agencies />} />
                    <Route path="staff" element={<Staff />} />
                    <Route path="payroll" element={<Payroll />} />
                    <Route path="expenses" element={<Expenses />} />
                    <Route path="purchase-orders" element={<PurchaseOrders />} />
                    <Route path="insights" element={<Insights />} />
                    <Route path="settings" element={<Settings />} />
                  </Route>
                </Routes>
              </DateRangeProvider>
            </ChannelProvider>
          </BrowserRouter>
        </CurrencyProvider>
      </LanguageProvider>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
